/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum Industry {
  AerospaceDefense = "AerospaceDefense",
  Automotive = "Automotive",
  Banking = "Banking",
  Brokerage = "Brokerage",
  BusinessServices = "BusinessServices",
  Construction = "Construction",
  Consulting = "Consulting",
  ConsumerPackagedGoods = "ConsumerPackagedGoods",
  ConsumerServices = "ConsumerServices",
  DiversifiedFinancialServices = "DiversifiedFinancialServices",
  Education = "Education",
  Energy = "Energy",
  FoodBeverages = "FoodBeverages",
  Government = "Government",
  HardwareElectronicsSemiconductors = "HardwareElectronicsSemiconductors",
  Healthcare = "Healthcare",
  HospitalityAttractions = "HospitalityAttractions",
  Insurance = "Insurance",
  InternetSocialMedia = "InternetSocialMedia",
  InvestmentBanking = "InvestmentBanking",
  LawFirms = "LawFirms",
  Manufacturing = "Manufacturing",
  Materials = "Materials",
  Media = "Media",
  MedicalDevicesDigitalHealth = "MedicalDevicesDigitalHealth",
  NA = "NA",
  NonProfit = "NonProfit",
  Other = "Other",
  PharmaBiotech = "PharmaBiotech",
  ProfessionalServices = "ProfessionalServices",
  RealEstate = "RealEstate",
  Retail = "Retail",
  Software = "Software",
  Telecom = "Telecom",
  Transportation = "Transportation",
  Utilities = "Utilities",
  VentureCapitalPrivateEquity = "VentureCapitalPrivateEquity",
}

export const IndustryDisplay: Record<Industry, string> = {
  [Industry.AerospaceDefense]: "Aerospace & Defense",
  [Industry.Automotive]: "Automotive",
  [Industry.Banking]: "Banking",
  [Industry.Brokerage]: "Brokerage",
  [Industry.BusinessServices]: "Business Services",
  [Industry.Construction]: "Construction",
  [Industry.Consulting]: "Consulting",
  [Industry.ConsumerPackagedGoods]: "Consumer Packaged Goods",
  [Industry.ConsumerServices]: "Consumer Services",
  [Industry.DiversifiedFinancialServices]: "Diversified Financial Services",
  [Industry.Education]: "Education",
  [Industry.Energy]: "Energy",
  [Industry.FoodBeverages]: "Food & Beverages",
  [Industry.Government]: "Government",
  [Industry.HardwareElectronicsSemiconductors]: "Hardware, Electronics, & Semiconductors",
  [Industry.Healthcare]: "Healthcare",
  [Industry.HospitalityAttractions]: "Hospitality & Attractions",
  [Industry.Insurance]: "Insurance",
  [Industry.InternetSocialMedia]: "Internet & Social Media",
  [Industry.InvestmentBanking]: "Investment Banking",
  [Industry.LawFirms]: "Law Firms",
  [Industry.Manufacturing]: "Manufacturing",
  [Industry.Materials]: "Materials",
  [Industry.Media]: "Media",
  [Industry.MedicalDevicesDigitalHealth]: "Medical Devices & Digital Health",
  [Industry.NA]: "NA",
  [Industry.NonProfit]: "Non-Profit",
  [Industry.Other]: "Other",
  [Industry.PharmaBiotech]: "Pharma & Biotech",
  [Industry.ProfessionalServices]: "Professional Services",
  [Industry.RealEstate]: "Real Estate",
  [Industry.Retail]: "Retail",
  [Industry.Software]: "Software",
  [Industry.Telecom]: "Telecom",
  [Industry.Transportation]: "Transportation",
  [Industry.Utilities]: "Utilities",
  [Industry.VentureCapitalPrivateEquity]: "Venture Capital & Private Equity",
};
